import './init'

// === SASS
import '../sass/main.scss'

// === Polyfills (mainly for IE11)
import '@nematis/js-snippets/assets/js/polyfills/_index'

// === Rousquille components
import BannerManager from './core/BannerManager'
import CookieManager from './core/CookieManager'
import GroupManager from './core/GroupManager'
import LangManager from './core/LangManager'
import ServiceManager from './core/ServiceManager'
import Logger from '@nematis/js-snippets/assets/js/logging/debug-logger'

// global params
const scripts = document.getElementsByTagName('script')
const path = scripts[scripts.length - 1].src.split('?')[0]
const rousquilleForceCDN = typeof window.rousquilleForceCDN === 'undefined' ? '' : window.rousquilleForceCDN
const cdn = rousquilleForceCDN === '' ? `${path.split('/').slice(0, -2).join('/')}/` : rousquilleForceCDN
let alreadyLaunch = typeof window.alreadyLaunch === 'undefined' ? false : window.alreadyLaunch

class Rousquille {
  constructor() {
    this.version = '1.15.0'
    this.events = {
      init: () => {
      },
      load: () => {
      }
    }
    this.cdn = cdn

    Logger.log(this)
  }

  config(params) {
    this.parameters = params
  }

  init() {
    if (alreadyLaunch === false) {
      alreadyLaunch = true

      window.addEventListener('load', () => {
        this.load()
      }, false)

      window.addEventListener('keydown', (evt) => {
        if (evt.keyCode === 27) {
          const panel = this.BM?.panel
          if (panel && panel.visible) {
            this.BM.closePanel()
          } else {
            this.BM.closeAlert()
          }
        }
      }, false)
    }

    // on charge les events
    if (this.events.init) {
      this.events.init()
    }
  }

  /**
   *
   */
  async load() {
    const environment = this.parameters.env || 'production'
    const defaults = {
      adblocker: false,
      hashtag: '#rousquille',
      cookieName: 'rousquille',
      cookieDomain: this.getCookieDomainDefault(environment),
      highPrivacy: false,
      orientation: 'top',
      removeCredit: true,
      showAlertSmall: true,
      cookieslist: true,
      handleBrowserDNTRequest: false,
      AcceptAllCta: false,
      denyAllCta: false,
      moreInfoLink: true,
      privacyUrl: '',
      useExternalCss: false,
      forceLanguage: false,
      forceExpire: false
    }

    // get params
    for (const k in defaults) {
      if (!this.parameters.hasOwnProperty(k)) {
        this.parameters[k] = defaults[k]
      }
    }

    // Set some parameters globals
    this.orientation = this.parameters.orientation
    this.hashtag = this.parameters.hashtag
    this.highPrivacy = this.parameters.highPrivacy
    this.handleBrowserDNTRequest = this.parameters.handleBrowserDNTRequest

    // Load Css
    const stylesheets = []

    if (this.parameters.useExternalCss === false) {
      stylesheets.push(`${this.cdn}build/main.css?v=${this.version}`)
      stylesheets.push(`${this.cdn}build/default-ui.css?v=${this.version}`)
    } else if (this.parameters.useExternalCss !== true) {
      stylesheets.push(this.parameters.useExternalCss)
    }

    stylesheets.forEach((href) => {
      const linkElement = document.createElement('link')
      linkElement.rel = 'stylesheet'
      linkElement.type = 'text/css'
      linkElement.href = href
      document.getElementsByTagName('head')[0].appendChild(linkElement)
    })

    // Load lang
    this.language = this.LM.getLanguage()
    this.translations = this.LM.getTranslations()

    // Wait until all services are loaded
    await this.SM.allServicesLoaded()

    // Initialize cookie
    this.CM.init(this.SM.services)
    this.CM.environment = this.parameters.environment
    this.CM.cookieDomain = this.parameters.cookieDomain

    // Initialize services status from cookies
    await this.SM.initServices()

    // Load Banners with DI of service & cookie Manager
    this.BM.init()

    // Events
    if (this.events.load) {
      this.events.load()
    }
  }

  /**
   * Get Banner Manager
   */
  get BM() {
    if (typeof this.BannerManager !== 'object') {
      this.BannerManager = new BannerManager(this.parameters, this.SM, this.CM, this.LM)
    }

    return this.BannerManager
  }

  /**
   * Get Cookie Manager
   */
  get CM() {
    if (typeof this.CookieManager !== 'object') {
      const settings = {
        environment: this.parameters.env,
        cookieDomain: this.parameters.cookieDomain || this.getCookieDomainDefault(this.parameters.env),
        name: this.parameters.cookieName,
        privacyUrl: this.parameters.privacyUrl
      }

      this.CookieManager = new CookieManager(settings)
    }

    return this.CookieManager
  }

  /**
   * Get Group Manager
   */
  get GM() {
    if (typeof this.GroupManager !== 'object') {
      this.GroupManager = new GroupManager()
    }

    return this.GroupManager
  }

  /**
   * Get Lang Manager
   */
  get LM() {
    if (typeof this.LangManager !== 'object') {
      this.LangManager = new LangManager(this.parameters.forceLanguage)
    }

    return this.LangManager
  }

  /**
   * Get Service Manager
   */
  get SM() {
    if (typeof this.ServiceManager !== 'object') {
      this.ServiceManager = new ServiceManager(this.parameters, this.CM)
    }

    return this.ServiceManager
  }

  getCookieDomainDefault(environment) {
    const domain = document.location.hostname
    switch (environment) {
      case 'production':
        return `.${domain.split('.').slice(-2).join('.')}`
      default:
        // use full domain during development
        return domain
    }
  }
}

window.rousquille = new Rousquille()

document.addEventListener('DOMContentLoaded', () => {
  // try to execute external callback and load Rousquille params
  if (typeof window.initRousquille === 'function') {
    window.initRousquille(window.rousquille)
  }
})
